export default __webpack_public_path__ + "static/media/swf-banner-desktop.ca571082.jpg";